import { TypedDocumentNode, gql } from '@apollo/client';
import { ComponentProps } from 'react';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Sport } from '__generated__/globalTypes';
import { Horizontal } from 'atoms/layout/flex';
import { Avatar } from 'components/user/Avatar';
import { ANY_SPORT_MY_CLUB_SLUG } from 'constants/__generated__/routes';
import { generateSportPath } from 'lib/routing/generateSportPath';

import { RivalsAvatar_footballRivalsManager } from './__generated__/index.graphql';

const RootLink = styled(Link)`
  width: fit-content;
`;
const AvatarWrapper = styled(Horizontal).attrs({ center: true })`
  position: relative;
  isolation: isolate;
  border-radius: 50%;
  border: 2px solid var(--c-black);
`;

type Props = {
  manager: RivalsAvatar_footballRivalsManager;
  hideStatus?: boolean;
} & Omit<ComponentProps<typeof Avatar>, 'user'>;
export const RivalsAvatar = ({ manager, hideStatus, ...rest }: Props) => {
  const { user } = manager;

  const getUrl = () => {
    return generateSportPath(ANY_SPORT_MY_CLUB_SLUG, {
      params: { slug: user.slug },
      sport: Sport.FOOTBALL,
    });
  };

  return (
    <RootLink to={getUrl()}>
      <AvatarWrapper>
        <Avatar size={8} rounded variant="responsive" user={user} {...rest} />
      </AvatarWrapper>
    </RootLink>
  );
};

RivalsAvatar.fragments = {
  footballRivalsManager: gql`
    fragment RivalsAvatar_footballRivalsManager on FootballRivalsManager {
      id
      user {
        slug
        ...Avatar_user
      }
    }
    ${Avatar.fragments.user}
  ` as TypedDocumentNode<RivalsAvatar_footballRivalsManager>,
};
